<template>
  <!-- The same head, drawn the way almost every beginner draws it:
       every feature fenced in by a hard line, no values at all. -->
  <svg class="headline" viewBox="0 0 420 560" role="img"
       aria-label="The same head drawn with hard outlines and no shading"
       xmlns="http://www.w3.org/2000/svg">
    <g fill="none" stroke="#c9d1da" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round">
      <!-- neck -->
      <path d="M168 372 L168 432 Q120 452 96 500 L96 560" />
      <path d="M252 372 L252 432 Q300 452 324 500 L324 560" />
      <!-- head -->
      <ellipse cx="210" cy="250" rx="122" ry="160" />
      <!-- hair, as a closed shape with a line around it -->
      <path d="M88 250 Q84 96 210 92 Q336 96 332 250 Q322 176 296 152 Q252 186 176 168 Q126 178 112 232 Z" />
      <!-- eyes: outlined almond + a perfectly centred pupil -->
      <path d="M133 252 Q163 232 193 252 Q163 272 133 252 Z" />
      <path d="M227 252 Q257 232 287 252 Q257 272 227 252 Z" />
      <circle cx="163" cy="252" r="10.5" />
      <circle cx="257" cy="252" r="10.5" />
      <!-- brows as flat bananas -->
      <path d="M132 224 Q163 208 194 220" />
      <path d="M226 220 Q257 208 288 224" />
      <!-- lashes as spokes -->
      <g stroke-width="2">
        <path d="M138 246 L133 238" /><path d="M152 240 L149 231" /><path d="M166 238 L166 229" />
        <path d="M180 240 L184 231" /><path d="M190 246 L196 238" />
        <path d="M232 246 L227 238" /><path d="M246 240 L243 231" /><path d="M260 238 L260 229" />
        <path d="M274 240 L278 231" /><path d="M284 246 L290 238" />
      </g>
      <!-- nose outlined all the way round -->
      <path d="M198 262 Q192 300 182 322 Q196 336 210 336 Q224 336 238 322 Q228 300 222 262" />
      <ellipse cx="189" cy="328" rx="6.5" ry="4.4" />
      <ellipse cx="231" cy="328" rx="6.5" ry="4.4" />
      <!-- mouth fenced in on all sides -->
      <path d="M170 360 Q190 350 210 355 Q230 350 250 360 Q230 372 210 369 Q190 372 170 360 Z" />
      <path d="M172 360 Q210 352 248 360" />
      <!-- ears -->
      <path d="M88 242 Q74 250 78 286 Q82 322 100 322" />
      <path d="M332 242 Q346 250 342 286 Q338 322 320 322" />
    </g>
  </svg>
</template>

<style scoped>
.headline { display: block; width: 100%; height: auto; background: #0a0d12; }
</style>
